<template>
  <v-dialog width="600" v-model="forward">
    <template v-slot:activator="{on}">
      <v-btn outlined color="success" v-on="on">
        <v-icon>mdi-share-outline</v-icon> Forward
      </v-btn>
    </template>
    <v-card>
      <v-toolbar flat>
        <v-autocomplete autofocus flat solo hide-details clearable
          prepend-inner-icon="mdi-magnify" label="Search"
          hide-no-data />
      </v-toolbar>
      <v-divider />
      <v-list>
        <v-list-item v-for="user in users" v-bind:key="user.id">
          <v-list-item-icon>
            <v-icon large>mdi-account-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{user.first_name}} {{user.last_name}}
            </v-list-item-title>
            <v-list-item-subtitle>{{user.description}}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch v-model="user.available" />
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-spacer />
        <v-btn text v-on:click="forward = false">cancel</v-btn>
        <v-btn text v-on:click="send" v-bind:disabled="disabled">send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'v-forward',
  data: () => ({
    forward: false,
    users: [
      {id: 1, first_name: 'Firdavs', last_name: 'Beknazarov', 
        description: 'SEO of SSASS Company', available: false},
      {id: 2, first_name: 'Ruslan', last_name: 'Roupov',
        description: 'Manager', available: false},
      {id: 3, first_name: 'Shaxlo', last_name: 'Alimova',
        description: 'Head cashier', available: false},
    ]
  }),
  methods: {
    send(){
      this.$router.push({name: 'dashboard'})
    }
  },
  computed: {
    disabled(){
      for(const index in this.users){
        if(this.users[index].available) return false
      }
      return true
    }
  }
}
</script>
